/*
 * @Description: 字符串扩展
 * @Author: shufei
 * @Date: 2021-11-18 18:11:39
 * @LastEditTime: 2021-11-18 18:11:39
 * @LastEditors: shufei
 */

// 获取地址栏参数
export const getQueryString = name => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}
